export default __webpack_public_path__ + "img/cRDdeDnE.b6dbbae3.svg";